const BASE = process.env.PUBLIC_URL + '/img/acero/';

const fotos = [
  { src: BASE + 'WhatsApp Image 2026-05-28 at 12.14.34 PM.jpeg',  caption: 'PTR y cuadros en bodega' },
  { src: BASE + 'WhatsApe 2026-05-28 at 12.14.35 PM.jpeg',        caption: 'Lámina acanalada' },
  { src: BASE + 'WhatsApp Image 2026-05-28 at 12.14.34 .jpeg',    caption: 'Tubo redondo' },
  { src: BASE + 'WhatsApp Ima026-05-28 at 12.14.34 PM.jpeg',      caption: 'Vista general del patio' },
  { src: BASE + 'WhatsApp Image 202-28 at 12.14.50 PM.jpeg',      caption: 'PTR cuadrado' },
  { src: BASE + 'WhatsApp Image 205-28 at 12.14.50 PM.jpeg',      caption: 'Stock de PTR' },
  { src: BASE + 'WhatsApp Image 2026-06-03 at 11.48.46 AM.jpeg', caption: 'Material disponible' },
  { src: BASE + 'WhatsApp Image 2026-06-03 at 11.48.47 AM.jpeg', caption: 'Inventario en patio' },
];

export default function Galeria() {
  return (
    <section className="galeria">
      <div className="container">
        <div className="section-header">
          <p className="section-overline">Nuestro material</p>
          <h2 className="section-title light">Nuestro Almacén</h2>
          <div className="section-divider" />
        </div>
      </div>

      <div className="galeria-grid">
        {fotos.map(({ src, caption }) => (
          <div key={src} className="galeria-item">
            <img src={src} alt={caption} loading="lazy" />
            <div className="galeria-overlay">
              <span className="galeria-caption">{caption}</span>
            </div>
          </div>
        ))}

      </div>
    </section>
  );
}
